import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { MatSnackBar } from '@angular/material/snack-bar';

interface UtilisateurNumeroEmploye {
  email: string;
  numeroEmploye: string;
}

@Component({
    selector: 'app-modifier-numero-employe',
    templateUrl: './modifier-numero-employe.component.html',
    styleUrls: ['./modifier-numero-employe.component.scss'],
    imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule
]
})
export class ModifierNumeroEmployeComponent {
  novoEntiteId: number | null = null;
  selectedFile: File | null = null;
  utilisateurs: UtilisateurNumeroEmploye[] = [];
  isLoading: boolean = false;
  fileName: string = '';

  constructor(
    private utilisateurService: UtilisateurService,
    private snackBar: MatSnackBar
  ) { }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    this.selectedFile = file;
    this.fileName = file.name;
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const content = e.target.result;
      const lines = content.split('\n');

      this.utilisateurs = lines
        .map((line: string) => line.trim())
        .filter((line: string) => line)
        .map((line: string) => {
          const parts = line.split(';');
          if (parts.length >= 2) {
            return {
              email: parts[0]?.trim() || '',
              numeroEmploye: parts[1]?.trim() || ''
            };
          }
          return { email: '', numeroEmploye: '' };
        })
        .filter((u: UtilisateurNumeroEmploye) => u.email && u.numeroEmploye);

      if (this.utilisateurs.length === 0) {
        this.snackBar.open('Le fichier CSV ne contient pas de données valides', 'Fermer', { duration: 5000 });
      }
    };

    reader.readAsText(file);
  }

  mettreAJour(): void {
    if (!this.novoEntiteId) {
      this.snackBar.open('Veuillez entrer un ID d\'entité', 'Fermer', { duration: 3000 });
      return;
    }

    if (this.utilisateurs.length === 0) {
      this.snackBar.open('Veuillez sélectionner un fichier CSV valide', 'Fermer', { duration: 3000 });
      return;
    }

    this.isLoading = true;

    this.utilisateurService.mettreAJourNumerosEmploye(this.utilisateurs, this.novoEntiteId).subscribe({
      next: () => {
        this.snackBar.open('Numéros d\'employé mis à jour avec succès', 'Fermer', { duration: 5000 });
        this.resetForm();
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors de la mise à jour:', error);
        this.snackBar.open(
          error.error?.message || 'Erreur lors de la mise à jour des numéros d\'employé',
          'Fermer',
          { duration: 5000 }
        );
        this.isLoading = false;
      }
    });
  }

  resetForm(): void {
    this.novoEntiteId = null;
    this.selectedFile = null;
    this.fileName = '';
    this.utilisateurs = [];
  }
}
